import {AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild,} from '@angular/core';

import {MatStepper} from '@angular/material/stepper';
import {Fournisseur} from '../../../domain/fournisseur/fournisseur';
import {TableUsineComponent} from './inscription-fournisseur/add-info-usine/table-usine/table-usine.component';
import {FournisseurService} from '../../../modules/services/fournisseur/fournisseur.service';
import {ToastService} from '../../../modules/toast/toast.service';
import {Router} from '@angular/router';
import {TransferidFournisseurService} from './transferid-fournisseur.service';
import {AgrementTableComponent} from './inscription-fournisseur/add-info-agrement/agrement-table/agrement-table.component';
import {MandataireTableComponent} from './inscription-fournisseur/add-info-mandataire/mandataire-table/mandataire-table.component';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {ConfirmDialogService} from '../../../modules/services/ui/confirm-dialog.service';
import {isEmpty} from '../../../utils/is-empty';
import {
    AddInformationGeneraleFournisseurComponent
} from './inscription-fournisseur/add-information-generale-fournisseur/add-information-generale-fournisseur.component';
import {CommmCode} from '../../../utils/constante/CommonCode';

@Component({
    selector: 'app-fournisseur',
    templateUrl: './fournisseur.component.html',
    styleUrls: ['./fournisseur.component.css'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: {showError: true},
        },
    ],
})
export class FournisseurComponent
    implements OnInit, AfterViewInit, AfterContentChecked {
    @ViewChild(MatStepper) stepper: MatStepper;
    @ViewChild('stepmandai') stepmandai: MatStepper;

    @ViewChild(TableUsineComponent) TableUsineComponent: TableUsineComponent;
    @ViewChild('agre')
    agre: AgrementTableComponent;
    @ViewChild('step1')
    step1: AddInformationGeneraleFournisseurComponent;
    @ViewChild('step6')
    step6: MandataireTableComponent;

    stepDisabled = true;
    type: Fournisseur;
    commonCode = CommmCode;
    currentStep: any;
    isvalid: any;

    constructor(
        private transferidfournisseurService: TransferidFournisseurService,
        private fournisseurservce: FournisseurService,
        private toast: ToastService,
        private routee: Router,
        private cdref: ChangeDetectorRef,
        private confirmDialogService: ConfirmDialogService
    ) {
    }

    onAdd() {
        // if (
        //     this.step1.form.valid &&
        //     this.step1.formtype.valid &&
        //     this.step1.formemail.valid
        // ) {
        //     this.stepper.next();
        // }
        this.stepper.next();
    }

    ngOnInit(): void {
    }

    submit(
        value: any,
        valuetype: any,
        valueemail: any,
        value2: any,
        value3: any,
        value4: any,
        value5: any,
        value6: any
    ) {
        const bj = Object.assign(
            value,
            valueemail,
            value2,
            value3,
            value4,
            value5,
            value6
        );
        if (isEmpty(value.national)) {
            value.national = valuetype.type;
        }

        if (value.national != 'TUN') {
            value.bizRegNo = value.national + '-' + value.bizRegNo;
        }
        /*    if (this.step1.formemail.invalid && this.step1.form.invalid) {
          this.confirmDialogService.error(
            "euillez remplir tous les champs obligatoires"
          );
        } else {*/
        this.fournisseurservce.addfourniisenur(bj).subscribe({
            next: (r) => {
                if (r.code != '200') {
                    this.toast.error();
                } else if ((r.code = '200')) {
                    this.transferidfournisseurService.setData(r['payload'].bizRegNo);
                    const d = r['payload'].bizRegNo;
                    this.toast.success('saved_successfully');
                    this.routee.navigateByUrl('/portail/recapfournisseur/' + d);
                }
            },
            error: (r) => {
            },
            complete: () => {
            },
        });
        /* }*/
    }

    ngAfterViewInit(): void {

    }

    ngAfterContentChecked(): void {
        this.cdref.detectChanges();
    }

    checkFormVaidity() {
        if (this.step1?.form) {
            return this.step1.form.valid && this.step1.formemail.valid && this.step1.formid.valid && this.step1.formtype.valid;
        }
        return false;
    }

    onAddagremment() {
        // if (this.step6.Ussine.length == 0) {
        //     this.confirmDialogService.error('mand_requi');
        // }
        // else {
        //     this.stepper.next();
        // }
        this.stepper.next();
    }

    isselected() {
        return this.stepmandai.selected && this.step6.Ussine.length == 0;
    }


}
